export const vmTemplateSubItems = (t: (key: string) => string) => [
  {
    to: "/vm-template/configuration",
    label: t("VmConfiguration"),
  },
  {
    to: "/vm-template",
    label: t("VmTemplate"),
    roles: ["INFRA_ADMIN"],
  },
  {
    to: "/vm-template/post-provisioning",
    label: t("PostProvisioning"), // fixed typo if intended
  },
  {
    to: "/vm-template/policies",
    label: t("Policies"),
  },
];